import React from 'react'
import ActivityEndedView from './ActivityEndedView'

interface LotteryMainContentProps {
  customerServiceUrl?: string
}

const LotteryMainContent: React.FC<LotteryMainContentProps> = ({ customerServiceUrl }) => {
  return <ActivityEndedView customerServiceUrl={customerServiceUrl} />
}

export default LotteryMainContent
